import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { MessageType } from "@/components/Playground/types";
import { Content } from "@/types";
import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface ChatMessagePayloadI {
  role: MessageType;
  content: Content[];
  tool_call_id?: string;
  name?: string;
}

export interface SendPlaygroundSessionChatMessageRequestI {
  variable_set_index: number;
  message: ChatMessagePayloadI | ChatMessagePayloadI[];
  stream?: boolean;
  mock_tool_responses?: boolean;
  mock_scenario?: string | null;
  mock_stop_tools?: string | null;
  prompt_id?: number | null;
  prompt_version_number?: number | null;
}

export interface SendPlaygroundSessionChatMessageResponseI {
  success: boolean;
  individual_run_request_id: number;
  user_message: ChatMessagePayloadI | ChatMessagePayloadI[];
  status: "queued";
}

export interface SendPlaygroundSessionChatMessageParamsI {
  workspaceId: number;
  sessionId: string;
  request: SendPlaygroundSessionChatMessageRequestI;
}

export const useAPISendPlaygroundSessionChatMessages = (
  userToken: string,
  options?: UseMutationOptions<
    SendPlaygroundSessionChatMessageResponseI,
    Error,
    SendPlaygroundSessionChatMessageParamsI
  >,
) =>
  useMutation<
    SendPlaygroundSessionChatMessageResponseI,
    Error,
    SendPlaygroundSessionChatMessageParamsI
  >(
    variables =>
      fetch(
        ENDPOINTS.playground_session_chat_messages(variables.workspaceId, variables.sessionId),
        {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
          body: JSON.stringify(variables.request),
        },
      ).then(handleResponse),
    options,
  );
